
if(!customElements.get('hotspot-arrivals')){
  customElements.define('hotspot-arrivals',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      const track=this.querySelector('.hs-arrivals__track');
      const buttons=this.querySelectorAll('[data-direction]');
      const update=()=>{
        buttons[0].disabled=track.scrollLeft<2;
        buttons[1].disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;
      };
      buttons.forEach(button=>button.addEventListener('click',()=>{
        const gap=parseFloat(getComputedStyle(track).columnGap)||0;
        track.scrollBy({left:Number(button.dataset.direction)*(track.clientWidth+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }));
      track.addEventListener('scroll',update,{passive:true});
      this.observer=new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback(){this.observer?.disconnect();this.ready=false;}
  });
}
